import { UiNodeAttributes, UiNodeInputAttributes } from '@ory/client'

// This method is copied from the ory UI library, because it is not typed properly there
export const isUiNodeInputAttributes = (
  attrs: UiNodeAttributes
): attrs is UiNodeInputAttributes => {
  return attrs.node_type === 'input'
}
